export class MeetingRoomResult {
    public id: number = 0;
    public name: string = '';
    public colorClass = '';
    public isDeleted: boolean = false;
}
